import { Stack, Typography } from "@mui/material";
import { useScreenWidthRange } from "../LandingOne";
import styled from "styled-components";
import muiStyled from "@mui/system/styled";

const MissionSection = () => {
  const isMobile = useScreenWidthRange(0, 768);
  const isTablet = useScreenWidthRange(768, 1024);

  const dataMission = [
    {
      subTitle: "About Us",
      title: "Mission",
      description:
        "Our mission is to reshape Indonesia's supply chain with innovative, AI-powered tools that streamline freight forwarding. We are dedicated to driving growth and efficiency across logistics—because we know how critical logistics are to our nation's growth.",
      image: "./assets/icon/images/mission.svg"
    }
  ];

  return (
    <SectionContainer id={"mission-section"}>
      {dataMission.map((item, index) => (
        <MissionContainer key={index} isMobile={isMobile} isTablet={isTablet}>
          {index % 2 === 0 && <img src={item.image} alt={"Mission" + index} />}

          <Stack
            key={index}
            direction={"column"}
            spacing={{ xs: "6px", sm: "12px" }}
          >
            <SubTitle>{item.subTitle}</SubTitle>

            <Title>{item.title}</Title>

            <Description>{item.description}</Description>
          </Stack>

          {index % 2 !== 0 && <img src={item.image} alt={"Mission" + index} />}
        </MissionContainer>
      ))}
    </SectionContainer>
  );
};

const SectionContainer = styled.section`
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
`;

type MissionContainerProps = {
  isMobile?: boolean;
  isTablet?: boolean;
};

const MissionContainer = styled.div<MissionContainerProps>`
  display: flex;
  flex-direction: ${({ isMobile, isTablet }) =>
    isMobile || isTablet ? "column" : "row"};
  align=items: center;
  justify-content: space-between;
  width: 100%;
  max-width: ${({ isMobile, isTablet }) =>
    isMobile || isTablet ? "100%" : "1200px"};
  padding: ${({ isMobile, isTablet }) =>
    isMobile || isTablet ? "0px 48px 24px" : "150px 0px"};
  gap: ${({ isMobile, isTablet }) => (isMobile || isTablet ? "50px" : "125px")};
`;

const SubTitle = muiStyled(Typography)(({ theme }) => ({
  color: "#0074FF",
  fontFamily: "Switzer",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "500",
  [theme.breakpoints.up("sm")]: {
    fontSize: "18px"
  }
}));

const Title = muiStyled(Typography)(({ theme }) => ({
  color: "#002376",
  fontFamily: "Switzer",
  fontSize: "28px",
  fontStyle: "normal",
  fontWeight: "500",
  [theme.breakpoints.up("sm")]: {
    fontSize: "42px"
  }
}));

const Description = muiStyled(Typography)(({ theme }) => ({
  color: "#3A5B98",
  fontFamily: "Switzer",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  [theme.breakpoints.up("sm")]: {
    fontSize: "18px"
  }
}));

export default MissionSection;
